export enum FiUploadType {
    // todo remove after finishing FI-4277
    Common = 0,
    Logo = 1,
    Background = 2,
}
